module.exports = __webpack_public_path__ + "img/basic_bar2.3b1a3ba5.png";